<template>
  <div class="m-table-admin m-table--large">
    <table>
      <thead>
        <tr class="m-table-admin__row">
          <th class="m-table-admin__col">{{ $t('business-list-business-label') }}</th>
          <th class="m-table-admin__col"></th>
        </tr>
      </thead>
      <admin-business-list-item v-for="business in value" :key="business.Id" :business="business" @businessUpdated="business => $emit('businessUpdated', business)" />
    </table>
  </div>
</template>

<script>
import AdminBusinessListItem from '@/components/dashboard/admin-business/admin-business-list-item'

export default {
  components: {
    AdminBusinessListItem
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
</script>
